


























import { Component, Vue, Prop } from 'vue-property-decorator'
import Moment from 'moment'
import { Recebimento } from '@/types/_'
import RecebimentoVuex from '@/store/RecebimentoVuex'

@Component

export default class ComponentRecebimentoCardList extends Vue {
  @Prop({ type: Object as () => Recebimento[] }) recebimento

  formatarData(data) {
    return Moment(data).format('DD/MM/YY')
  }

  formatarDataUrl(data) {
    return Moment(data).format('YYYY-MM-DD')
  }

  recebimentoDetail(recebimento) {
    this.setFontePagadora(recebimento.fontePagadora)
    this.ga('recebimento', 'recebimento-item')
    this.redirect(`/recebimento-detalhe/${recebimento.contratoId}/${this.formatarDataUrl(recebimento.previsaoRecebimento)}`)
  }

  setFontePagadora(value) {
    RecebimentoVuex.commit('SET_FONTE_PAGADORA_SELECTED', value)
  }

  redirect(redirect) {
    this.$router.push(redirect)
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  mounted() {
    this.ga('recebimento', 'recebimento-list')
  }
}
